<template>
  <div class="mint-cell-value">
    <span>{{item.levelDescript}}</span>
    <span class='spe-checkbox'
          :class='{active : item.selected}'
          v-if='item.level == 200 && isMultSelect && !item.opera'>
      <i class='iconfont icon-right'></i>
    </span>
  </div>
</template>
<script>
  export default {
    data() {
      return {}
    },
    props: {
      item: {
        type: Object,
        default() {
          return {}
        }
      },
      isMultSelect: {
        type: Boolean,
        default: false
      }
    }
  }
</script>

<style lang="less">

  .spe-checkbox {
    display: inline-block;
    width: 18px;
    height: 18px;
    line-height: 18px;
    border: 1px solid #999;
    color: #999;
    border-radius: 4px;
    text-align: center;
    margin-left: 10px;
    box-sizing: border-box;

    .iconfont {
      display: none;
    }

    &.active {
      border: 1px solid orange;
      background: orange;
      color: #fff;

      .iconfont {
        display: inline-block;
      }
    }
  }

</style>



// WEBPACK FOOTER //
// searchHotelRightPart.vue?69053961